export const theme = {
  blackText: "#000",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#007E7D",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "#717171",
  greyText10: "#c8c2c2",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  blueText2: "#F6FAFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenBg: "rgba(43, 130, 94, 0.5)",
  purpleGradient: "linear-gradient(91.22deg, #3023ae 1.88%, #c86dd7 100%)",
  blueGradient: "linear-gradient(to right,#53B2FE,#065AF3)",
  myBizGradient: "linear-gradient(104.41deg, #FF7E40 0%, #FF405D 99.23%)",
  neonGreen: "#E6FFF9",
  orange: "#FF6E39",
  disabledGrey: "#0000004D",
  disabledGrey2: "#F2F2F2",
  darkGreyBg: "#E7E7E7",
  lightBlueBg: "#EAF5FF",
};

export const fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900",
};

export const fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px",
};

export const lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px",
};
